import script from "./product6View.vue?vue&type=script&setup=true&lang=js"
export * from "./product6View.vue?vue&type=script&setup=true&lang=js"

import "./product6View.vue?vue&type=style&index=0&id=d7abfd3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7abfd3e"]])

export default __exports__